import { createStyles } from '@material-ui/core/styles';

export function styles() {
  return createStyles({
    root: {},
    labelRoot: {},
    errorText: {},
    tooltip: { display: 'flex', width: '100%' },
    groupItem: {},
  });
}
